import * as angular from 'angular';

class TsoSettingDescriptionComponentCtrl implements ng.IController {}

/**
 * @ngdoc directive
 * @name pkpTsoSettingDescription
 * @memberof app
 *
 * @description
 * Shows the title/subtitle, description and external documentation link in the operator settings.
 *
 * @param {string} title The title of the setting.
 * @param {string} link The external documentation link.
 * @param {boolean} hideHr Tells whether a line should be displayed in case the directive is used in a new setting section.
 * @param {boolean] pullLeft Tells whether the entire description shall be pulled left or not.
 * @param {string} subTitle If set, the directive is used in a subsection, therefore a sub title is required.
 *
 * @author flzemke.btc, mabarbat.btc
 */
angular.module('app').component('pkpTsoSettingDescription', {
    controller: TsoSettingDescriptionComponentCtrl,
    template: require('app/_directives/tso-setting-description.component.html'),
    bindings: {
        title: '@',
        link: '@',
        hideHr: '=',
        pullLeft: '=',
        subTitle: '@'
    },
    transclude: true
});
